import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import DueDateCalculator from '../../DueDate/CalculatorBox/DueDateCalculator';
import ShowResult from '../DueDateResultPage';
import {
  DateCalculateBtn,
  DueDatePregnancyPage,
  LeftColumn,
  RightColumn,
  SelectDate,
} from '../styled';

function DueDate(props) {
  const { setCurrentWeek } = props;
  const [dueDate, setDueDate] = useState(null);
  const { query } = useRouter();
  const router = useRouter();
  // getGrowthData()
  useEffect(() => {
    if (query.result == 'true' && !dueDate) {
      const search = new URLSearchParams(window.location.search);
      search.delete('result');
      let params = '';
      if (search.toString() != '') {
        params = '?' + search.toString();
      }
      router.replace(router.route + params, '', {
        shallow: true,
      });
    }
  }, [query]);

  return (
    <DueDatePregnancyPage>
      <LeftColumn>
        <h4> Calculate your due date</h4>
        <p>
          Prepare for baby&apos;s arrival with Mylo Due Date Calculator. Learn
          your due date and begin the countdown to the big day!
        </p>
      </LeftColumn>
      <RightColumn>
        {dueDate && query.result == 'true' ? (
          <ShowResult dueDate={dueDate} setDueDate={setDueDate} />
        ) : (
          <>
            <h5>When did your last period start?</h5>
            <DueDateCalculator
              setDueDate={setDueDate}
              DateCalculateBtn={DateCalculateBtn}
              buttonText={'CALCULATE'}
              SelectDate={SelectDate}
              setCurrentWeek={setCurrentWeek}
            />
          </>
        )}
      </RightColumn>
    </DueDatePregnancyPage>
  );
}

export default DueDate;
